import { Wrapper } from 'AppReact';
import styled from 'styled-components';

const template = styled.tr`
  height: 44px;
  border-radius: 4px;

  td {
    width: 20%;
    border: solid 1px #E3E3E3;
    border-style: none solid solid none;
    padding-left: 10px;
    padding-right: 10px;
    text-align: center;
    cursor: pointer;
    &:hover {
      border: solid 1px ${window?.settings?.primary_color ?? '#1DBD6B'};
    }
  }

  &:first-child td:first-child { border-top-left-radius: 4px; }
  &:first-child td:last-child { border-top-right-radius: 4px; }

  &:last-child td:first-child { border-bottom-left-radius: 4px; }
  &:last-child td:last-child { border-bottom-right-radius: 4px; }

  &:first-child td { border-top-style: solid; }
  td:first-child { border-left-style: solid; }
`;

export default Wrapper(template);